import { Phone, Clock, Mail, MapPin } from "lucide-react";
import { site } from "@/lib/site";

const TopBar = () => {
  return (
    <div className="hidden sm:block bg-accent text-accent-foreground">
      <div className="container-max flex flex-col sm:flex-row items-center justify-between px-4 py-2 text-xs sm:text-sm gap-1 sm:gap-0">
        <div className="flex items-center gap-4">
          <a href={site.emailHref} className="flex items-center gap-2 hover:text-secondary transition-colors">
            <Mail className="h-3.5 w-3.5 text-secondary" />
            <span>{site.email}</span>
          </a>
          <div className="hidden md:flex items-center gap-2">
            <MapPin className="h-3.5 w-3.5 text-secondary" />
            <span>{site.serviceArea}</span>
          </div>
        </div>
        <div className="flex items-center gap-4">
          <div className="hidden lg:flex items-center gap-2">
            <Clock className="h-3.5 w-3.5 text-secondary" />
            <span>{site.hoursShort}</span>
          </div>
          <a href={site.phoneHref} className="flex items-center gap-2 hover:text-secondary transition-colors font-semibold">
            <Phone className="h-3.5 w-3.5 text-secondary" />
            <span>{site.phone}</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
